import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'popup'];

  get isOpen() {
    return !this.popupTarget.hidden;
  }

  toggle() {
    return this.isOpen ? this.close() : this.open();
  }

  open() {
    this.popupTarget.hidden = false;
    this.buttonTarget.setAttribute('aria-expanded', true);
    window.addEventListener('keydown', this.closeOnEsc);
    window.addEventListener('click', this.closeOnClick);
  }

  close = () => {
    this.popupTarget.hidden = true;
    this.buttonTarget.setAttribute('aria-expanded', false);
    window.removeEventListener('keydown', this.closeOnEsc);
    window.removeEventListener('click', this.closeOnClick);
  };

  closeOnEsc = (e) => {
    if (e.key === 'Escape') {
      this.close();
    }
  };

  closeOnClick = (e) => {
    if (e.target.closest('button') === this.buttonTarget) {
      return;
    }

    this.close();
  };
}
